module.exports = "/_next/static/images/3110a9c90f7deda520b9397dd95087ed-purple-box-icon.svg.webp";